module.exports = __webpack_public_path__ + "static/img/Tom-Trbojevic.5c38749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Trbojevic.jpg
// module id = qxL/
// module chunks = 0